/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPhoneCall = createReactComponent("outline", "phone-call", "IconPhoneCall", [["path", { "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M15 7a2 2 0 0 1 2 2", "key": "svg-1" }], ["path", { "d": "M15 3a6 6 0 0 1 6 6", "key": "svg-2" }]]);

export { IconPhoneCall as default };
//# sourceMappingURL=IconPhoneCall.mjs.map
